module.exports = "/assets/google-play-badge.png?fi8ibhN";